import { Link } from "react-router-dom";
import { BarChart3 } from "lucide-react";
import { isAdminSession } from "@/lib/adminAuth";

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-blue-500 rounded-lg flex items-center justify-center">
                <BarChart3 className="h-5 w-5 text-white" />
              </div>
              <span className="text-xl font-bold font-['Outfit']">Selletrust</span>
            </Link>
            <p className="text-slate-400 text-sm max-w-md">
              Build trust through reputation. We help businesses monitor reviews, 
              manage their online presence, and grow with confidence.
            </p>
          </div>
          
          {/* Links */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-400">Product</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/lookup" className="text-slate-300 hover:text-white transition-colors">Analyze Business</Link></li>
              {isAdminSession() && (
                <li><Link to="/reports" className="text-slate-300 hover:text-white transition-colors">View Reports</Link></li>
              )}
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-400">Analysis</h4>
            <ul className="space-y-2 text-sm text-slate-300">
              <li>Listings</li>
              <li>Reviews</li>
              <li>Social Media</li>
              <li>Website & SEO</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Selletrust. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-slate-500">
            <span>Privacy Policy</span>
            <span>Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
